export default __webpack_public_path__ + "static/media/Emm_dark.34bb8684.png";